import type { ContratCxpiDTO } from '@/features/api/extranet/dto/Demande/CXPI'
import type { SousDispositif } from '@/features/domaine/types/opco/Demande/CXPI'

export const preNotNirTemporaire = (_value: any, _parent: any, modele: ContratCxpiDTO) =>
  modele.salarie?.nirTemporaire !== true

export const preNirTemporaire = (_value: any, _parent: any, modele: ContratCxpiDTO) =>
  modele.salarie?.nirTemporaire === true

const preSousDipositifBuilder = (sousDispostif: SousDispositif) =>
  (_value: any, _parent: any, model: ContratCxpiDTO) =>
    model.sousDispositif === sousDispostif

export const preEstCIPI = preSousDipositifBuilder('CIPI')
export const preEstCDPI = preSousDipositifBuilder('CDPI')

